module.exports = __webpack_public_path__ + "static/media/anc3kz.0f417dc5.pdf";